import React from "react";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import Overlay from "../../ui/Overlay";
import { OverlayBlock } from "../../lib/storyblok/types/blocks/OverlayBlock";
import VideoPlayer from "../../ui/Common/VideoPlayer";
import StoryblokImage from "../StoryblokImage";
import Button from "../../ui/Button";
import { useLinks } from "../../lib/storyblok/useLinks";
import { useContentStyle, useButtonStyle } from "../../hooks/useStyle";
import { isValidImageData, imageSizes } from "../../lib/utils/imageUtils";

const OverlayBlock: StoryblokBlockComponent<OverlayBlock> = ({
  title,
  description,
  buttons,
  image,
  video,
  overlayStyle,
  overlayOpacity,
  contentAlignment,
  innerSpacing,
  outerSpacing,
  width,
}) => {
  const resolveLink = useLinks();
  const isInverted = useContentStyle(overlayStyle);
  const { buttonVariant } = useButtonStyle(overlayStyle);

  const buttonCollection = buttons?.map((button) => (
    <Button
      variant={button.buttonType || buttonVariant || "default"}
      key={button._uid}
      href={button.buttonLink ? resolveLink(button.buttonLink) : ""}
    >
      {button.buttonText}
    </Button>
  ));

  return (
    <Overlay
      title={title}
      description={description}
      buttons={buttonCollection}
      image={
        image &&
        isValidImageData(image) && (
          <StoryblokImage
            image={image}
            layout="fill"
            alt={title}
            sizes={imageSizes("100vw", {
              desktop: "1200px",
              xl: "1600px",
            })}
          />
        )
      }
      video={
        video?.filename && (
          <VideoPlayer
            key="video"
            videoUrl={video?.filename}
            thumbnail={
              image &&
              isValidImageData(image) && (
                <StoryblokImage
                  image={image}
                  layout="fill"
                  sizes={imageSizes("100vw", {
                    desktop: "1200px",
                    xl: "1600px",
                  })}
                  objectFit="cover"
                  priority
                  alt={title}
                />
              )
            }
            thumbnailMode="thumbnailOnly"
            isActive={true}
          />
        )
      }
      overlayStyle={overlayStyle}
      overlayOpacity={overlayOpacity.value}
      contentAlignment={contentAlignment}
      innerSpacing={innerSpacing}
      outerSpacing={outerSpacing}
      width={width}
      inverted={isInverted}
    />
  );
};

export default OverlayBlock;
